export default "__VITE_ASSET__Bp2BTsoN__"